export const defaultGoogleAdsSettings = () => {};
